/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from 'react';
import SearchJuridico from 'components/atoms/search_juridico';
import { useDispatch, useSelector } from 'react-redux';
import { search_type } from 'store/modules/juridico_facil_store/actions';
import ListAcervo from 'components/molecules/list_acervo';
import { ApplicationState } from 'store';
import { JuridicoFacilState } from 'store/modules/juridico_facil_store/types';
import Loader from 'components/atoms/loader';
import OpenTutorial from 'components/atoms/open_tutorial';

interface JuridicoSearchProps {
  params: {
    search?: string;
    tipo?: string;
    accept?: boolean;
    video?: boolean;
    area?: string;
    tema?: string;
    subtema?: string;
  };
}

const JuridicoSearch = (props: JuridicoSearchProps) => {
  const { params } = props;
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);

  const { juridico, request } = useSelector<ApplicationState, JuridicoFacilState>(
    (state) => state.session.juridico,
  );

  useEffect(() => {
    document.title = 'Jurídico Fácil - ConLicitação';
    dispatch(search_type(params, currentPage));
  }, [currentPage]);

  return (
    <div className="mt-5 py-2">
      <div className="container p-4 mt-2">
        <div className="row">
          <div className="col-md-12">
            <div className="d-md-flex d-block align-items-center mb-3">
              <h4 className="mb-1 mr-3 font-weight-bold">Jurídico Fácil</h4>
              <OpenTutorial type="modal" source="juridico" />
            </div>
          </div>
        </div>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/juridico">Início</a>
            </li>
            <li className="breadcrumb-item">Resultados</li>
          </ol>
        </nav>

        <div className="row">
          <div className="col-md-12">
            <SearchJuridico params={params} />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-3 pr-0">
            <h6 className="font-weight-bold">Filtrar por</h6>
            <div className="card mb-2">
              <div className="card-header">Tipo</div>
              <ul className="list-group list-group-flush pt-2 pb-1">
                {juridico?.qnt_por_tipo_sumula > 0 && (
                  <li
                    className="list-group-item text-secondary border-0 pb-1 pt-0"
                    style={{ fontSize: '13px' }}
                  >
                    <a
                      href={`/juridico/search/${params?.search}/3/${params?.accept}/${params?.video}`}
                    >
                      Súmula
                    </a>
                    <span className="badge badge-primary ml-2">
                      {juridico?.qnt_por_tipo_sumula}
                    </span>
                  </li>
                )}
                {juridico?.qnt_por_tipo_jurisprudencia > 0 && (
                  <li
                    className="list-group-item text-secondary border-0 pb-1 pt-0"
                    style={{ fontSize: '13px' }}
                  >
                    <a
                      href={`/juridico/search/${params?.search}/1/${params?.accept}/${params?.video}`}
                    >
                      Jurisprudência
                    </a>
                    <span className="badge badge-primary ml-2">
                      {juridico?.qnt_por_tipo_jurisprudencia}
                      {juridico?.qnt_por_tipo_jurisprudencia_limitada && '+'}
                    </span>
                  </li>
                )}
                {juridico?.qnt_por_tipo_dica > 0 && (
                  <li
                    className="list-group-item text-secondary border-0 pb-1 pt-0"
                    style={{ fontSize: '13px' }}
                  >
                    <a
                      href={`/juridico/search/${params?.search}/3/${params?.accept}/${params?.video}`}
                    >
                      Dica Legal
                    </a>
                    <span className="badge badge-primary ml-2">{juridico?.qnt_por_tipo_dica}</span>
                  </li>
                )}
                {juridico?.qnt_leis > 0 && (
                  <li
                    className="list-group-item text-secondary border-0 pb-1 pt-0"
                    style={{ fontSize: '13px' }}
                  >
                    <a
                      href={`/juridico/search/${params?.search}/4/${params?.accept}/${params?.video}`}
                    >
                      Legislação
                    </a>
                    <span className="badge badge-primary ml-2">{juridico?.qnt_leis}</span>
                  </li>
                )}
              </ul>
            </div>
            {juridico?.qnt_por_area?.length > 0 && (
              <div className="card mb-2">
                <div className="card-header">Área</div>
                <ul className="list-group list-group-flush pt-2 pb-1">
                  {juridico?.qnt_por_area?.map((area) => (
                    <li
                      key={area?.id}
                      className="list-group-item text-secondary border-0 pb-1 pt-0"
                      style={{ fontSize: '13px' }}
                    >
                      <a
                        href={`/juridico/search/${params?.search}/${params?.tipo}/${params?.accept}/${params?.video}/${area?.id}`}
                      >
                        {area?.descricao}
                      </a>
                      <span className="badge badge-primary ml-2">{area?.total}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {juridico?.qnt_por_tema_licitacao?.length > 0 && (
              <div className="card mb-2">
                <div className="card-header">Tema</div>
                <ul className="list-group list-group-flush pt-2 pb-1">
                  {juridico?.qnt_por_tema_licitacao?.map((tema) => (
                    <li
                      className="list-group-item text-secondary border-0 pb-1 pt-0"
                      style={{ fontSize: '13px' }}
                    >
                      <a
                        href={`/juridico/search/${params?.search}/${params?.tipo}/${params?.accept}/${params?.video}/2/${tema?.id}`}
                      >
                        {tema?.descricao}
                      </a>
                      <span className="badge badge-primary ml-2">{tema?.total}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {juridico?.qnt_por_subtema_licitacao?.length > 0 && (
              <div className="card mb-2">
                <div className="card-header">Subtema</div>
                <ul className="list-group list-group-flush pt-2 pb-1">
                  {juridico?.qnt_por_subtema_licitacao?.map((subtema) => (
                    <li
                      className="list-group-item text-secondary border-0 pb-1 pt-0"
                      style={{ fontSize: '13px' }}
                    >
                      <a
                        href={`/juridico/search/${params?.search}/${params?.tipo}/${params?.accept}/${params?.video}/2/${params?.tema}/${subtema?.id}`}
                      >
                        {subtema?.descricao}
                      </a>
                      <span className="badge badge-primary ml-2">{subtema?.total}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          <div className="col-md-9">
            {request?.search?.loading ? (
              <Loader />
            ) : (
              <ListAcervo
                word={params?.search ? params?.search : ''}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JuridicoSearch;
